// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"76025993","977":"120d3c8a"}[chunkId] + ".chunk.js";
};